import {uniqueId, sample} from 'lodash';
import saveTrack from '../../../utils/gaia/saveTrack';
import {boldTrackColors} from '../../../utils/gaia/trackColors';
import trackAnalytics from '../../../utils/gaia/trackAnalytics';
import {AddSavePromise} from '../../useIsSaved';

// eslint-disable-next-line max-params
export default function create(
    action: CreateTrackAction,
    tracks: {[trackLocalId: string]: Track},
    setTracks: React.Dispatch<React.SetStateAction<{[trackLocalId: string]: Track}>>,
    project: MapProject,
    addSavePromise: AddSavePromise,
) {
    trackAnalytics('Create Route', {category: 'map2'});
    const trackLocalId = uniqueId('track');

    const track: Track = {
        properties: {
            trackLocalId,
            color: sample(boldTrackColors) as string,
            writable: true,
            title: 'untitled',
            isLocallyDeleted: false,
            isPublicTrack: false,
            track_type: 'route',
            routing_mode: 'pedestrian',
            isLocallyCreated: true,
            time_created: (new Date()).toISOString(),
        },
        isGeometryLoaded: true,
        points: {},
    };

    setTracks({
        ...tracks,
        [trackLocalId]: track
    });

    if (action.save === true) saveTrack(track, project, addSavePromise);

    return trackLocalId;
}
